export const WORK_ORDER_AUTO_REFRESH_INTERVAL_MS = 30_000;

export const WORK_ORDER_AUTO_REFRESH_QUERY_OPTIONS = {
  refetchInterval: WORK_ORDER_AUTO_REFRESH_INTERVAL_MS,
  refetchIntervalInBackground: true,
} as const;
